//src/styles/components/MuiDivider.js

import palette from "../palette";

const MuiDivider = {
  styleOverrides: {
    root: { 
      borderColor: palette.utility?.divider || palette.raw?.border || "#e0e0e0" 
    }
  },
};

export default MuiDivider;